import React from 'react';
import './Landing.css';
import Header from './Header';
import { SparklesIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const Landing = () => {
  return (
    <div className="Landing__container">
      <Header />
      
        <section className="Landing__hero">
          <div className="Landing__content-container">
            <div className="Landing__hero-content">
              <h1>Договоры на понятном языке</h1>
              <p>Загружайте договоры и получайте их упрощенную версию без юридических сложностей</p>
              <a href="/auth" className="Landing__cta-button">Начать бесплатно</a>
            </div>
            <div className="Landing__hero-image">
              <svg
                className="Landing__hero-svg"
                width="380"
                height="290"
                viewBox="0 0 420 330"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <filter id="cardShadow" x="-30%" y="-30%" width="160%" height="160%">
                    <feDropShadow dx="0" dy="8" stdDeviation="8" floodColor="rgba(0, 0, 0, 0.15)" />
                  </filter>
                </defs>

                {/* Фон карточки */}
                <rect
                  x="20"
                  y="20"
                  width="380"
                  height="290"
                  rx="24"
                  fill="#ffffff"
                  filter="url(#cardShadow)"
                />

                {/* Вертикальная разделительная линия */}
                <line x1="210" y1="60" x2="210" y2="270" stroke="#c7d8ff" strokeWidth="2" />

                {/* Заголовки */}
                <text
                  x="115"
                  y="80"
                  textAnchor="middle"
                  fontSize="20"
                  fill="#b0bec5"
                  fontWeight="400"
                  fontFamily="Arial, sans-serif"
                >
                  Юридический
                </text>
                <text
                  x="115"
                  y="105"
                  textAnchor="middle"
                  fontSize="20"
                  fill="#b0bec5"
                  fontWeight="400"
                  fontFamily="Arial, sans-serif"
                >
                  текст
                </text>

                <text
                  x="305"
                  y="80"
                  textAnchor="middle"
                  fontSize="20"
                  fill="#7a9cc6"
                  fontWeight="400"
                  fontFamily="Arial, sans-serif"
                >
                  Человеческий
                </text>
                <text
                  x="305"
                  y="105"
                  textAnchor="middle"
                  fontSize="20"
                  fill="#7a9cc6"
                  fontWeight="400"
                  fontFamily="Arial, sans-serif"
                >
                  текст
                </text>

                {/* Левые полосы */}
                <rect x="55" y="140" width="120" height="20" rx="10" fill="#b0bec5" />
                <rect x="55" y="175" width="120" height="20" rx="10" fill="#b0bec5" />
                <rect x="55" y="210" width="100" height="20" rx="10" fill="#b0bec5" />
                <rect x="55" y="245" width="80" height="20" rx="10" fill="#b0bec5" />

                {/* Правые полосы */}
                <rect x="245" y="140" width="120" height="20" rx="10" fill="#a3c8ff" />
                <rect x="245" y="175" width="100" height="20" rx="10" fill="#a3c8ff" />
                <rect x="245" y="210" width="120" height="20" rx="10" fill="#a3c8ff" />
                <rect x="245" y="245" width="80" height="20" rx="10" fill="#a3c8ff" />
              </svg>
            </div>
          </div>
        </section>
        
        <section className="Landing__features">
          <div className="Landing__content-container">
            <h2>Возможности сервиса</h2>
            <div className="Landing__features-grid">
              <div className="Landing__feature-card">
                <div className="Landing__feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#2196F3" width="32" height="32">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                  </svg>
                </div>
                <h3>Выделение пунктов</h3>
                <p>Автоматическое выделение ключевых пунктов договора</p>
              </div>
              <div className="Landing__feature-card">
                <div className="Landing__feature-icon">
                  <SparklesIcon width={32} height={32} style={{ color: '#2196F3' }} />
                </div>
                <h3>Упрощение текста</h3>
                <p>Перевод юридического языка на понятный человеческий</p>
              </div>
              <div className="Landing__feature-card">
                <div className="Landing__feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#2196F3" width="32" height="32">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                  </svg>
                </div>
                <h3>Экспорт результатов</h3>
                <p>Получение анализа в веб-интерфейсе, PDF и DOCX форматах</p>
              </div>
            </div>
          </div>
        </section>
        
        <section className="Landing__example">
          <div className="Landing__content-container">
            <h2>Перевод на человеческий язык</h2>
            <p className="Landing__example-description">Сервис преобразует сложные юридические формулировки в простой и понятный текст</p>
            <div className="Landing__dual-list">
              {/* Пункт 1 */}
              <div className="Landing__dual-card">
                <div className="Landing__dual-section left">
                  <p>Если арендатор задерживает оплату более 5 дней, арендодатель вправе начислить пеню в размере 0,05% за каждый день просрочки.</p>
                </div>
                <div className="Landing__dual-section right">
                  <p>За просрочку оплаты больше 5 дней начисляется штраф 0,05% за каждый день.</p>
                </div>
              </div>

              {/* Пункт 2 */}
              <div className="Landing__dual-card">
                <div className="Landing__dual-section left">
                  <p>Заказчик имеет право расторгнуть договор в одностороннем порядке, уведомив Исполнителя не позднее чем за 10 календарных дней.</p>
                </div>
                <div className="Landing__dual-section right">
                  <p>Заказчик может отменить договор, предупредив Исполнителя за 10 дней.</p>
                </div>
              </div>

              {/* Пункт 3 */}
              <div className="Landing__dual-card">
                <div className="Landing__dual-section left">
                  <p>Исполнитель обязан устранить выявленные недостатки в течение 7 рабочих дней с момента получения уведомления Заказчика.</p>
                </div>
                <div className="Landing__dual-section right">
                  <p>Исполнитель должен исправить проблемы в течение 7 рабочих дней после уведомления.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <section className="Landing__key-points">
          <div className="Landing__content-container">
            <h2>Ключевая информация из договора</h2>
            <p className="Landing__key-points-description">Сервис автоматически выделяет самую важную информацию из документа</p>
            
            <div className="Landing__key-points-container">
              <div className="Landing__key-point-card">
                <h3>Срок действия договора</h3>
                <p>Договор вступает в силу с момента подписания и действует до 31 декабря 2023 года</p>
              </div>
              
              <div className="Landing__key-point-card">
                <h3>Стоимость услуг</h3>
                <p>Общая стоимость составляет 120 000 рублей, НДС не облагается</p>
              </div>
              
              <div className="Landing__key-point-card">
                <h3>Штрафы</h3>
                <p>За просрочку оплаты - 0,1% от суммы за каждый день, но не более 10% от общей суммы</p>
              </div>
              
              <div className="Landing__key-point-card">
                <h3>Контакты сторон</h3>
                <p>ООО "Заказчик": г. Москва, ул. Примерная, д. 1, тел: +7 (495) 123-45-67<br/>
                ООО "Исполнитель": г. Санкт-Петербург, пр. Образцовый, д. 2, тел: +7 (812) 765-43-21</p>
              </div>
              
              <div className="Landing__key-point-card">
                <h3>Разрешение споров</h3>
                <p>Все споры решаются путем переговоров, при недостижении согласия - в Арбитражном суде г. Москвы</p>
              </div>
              
              <div className="Landing__key-point-card">
                <h3>Конфиденциальность</h3>
                <p>Стороны обязуются не разглашать информацию, полученную в ходе исполнения договора, в течение 3 лет</p>
              </div>
            </div>
          </div>
        </section>
        
        {/* === QA Section: Answers to document questions === */}
        <section className="Landing__qa">
          <div className="Landing__content-container">
            <h2>Ответы на вопросы по документу</h2>
            <p className="Landing__qa-description">Сервис отвечает на ваши вопросы, опираясь на содержимое договора</p>

            <div className="Landing__chat-container">
              <div className="Landing__chat-message user">
                <p>Может ли арендодатель повысить стоимость аренды раньше срока, указанного в договоре?</p>
              </div>
              <div className="Landing__chat-message ai">
                <p>Нет. Договор прямо запрещает изменение стоимости аренды до истечения указанного срока без вашего согласия.</p>
              </div>
            </div>
          </div>
        </section>
        
        <section className="Landing__translation">
          <div className="Landing__content-container">
            <h2>Перевод с иностранных языков</h2>
            <p className="Landing__translation-description">Сервис автоматически переводит договоры с иностранных языков и упрощает их</p>
            
            <div className="Landing__example-container three-columns">
              <div className="Landing__example-item">
                <h3>Оригинальный текст (EN)</h3>
                <div className="Landing__example-card original">
                  <p>In the event of termination of this Agreement for any reason, the Confidentiality obligations set forth in Section 7 shall survive such termination and shall remain in full force and effect for a period of three (3) years from the date of termination.</p>
                </div>
              </div>
              <div className="Landing__example-arrow">
                <div className="Landing__arrow-icon"></div>
              </div>
              <div className="Landing__example-item">
                <h3>Перевод</h3>
                <div className="Landing__example-card translation">
                  <p>В случае прекращения действия настоящего Соглашения по любой причине, обязательства по конфиденциальности, изложенные в Разделе 7, сохраняют свою силу после такого прекращения и остаются в полной силе и действии в течение трех (3) лет с даты прекращения.</p>
                </div>
              </div>
              <div className="Landing__example-arrow">
                <div className="Landing__arrow-icon"></div>
              </div>
              <div className="Landing__example-item">
                <h3>Упрощенная версия</h3>
                <div className="Landing__example-card simplified">
                  <p>Даже если договор закончится, вы должны хранить конфиденциальную информацию в тайне ещё 3 года.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <section className="Landing__cta-section">
          <div className="Landing__content-container">
            <h2>Начните понимать свои договоры прямо сейчас</h2>
            <p className="Landing__cta-description">Загрузите документ и получите его понятную версию за считанные минуты</p>
            <a href="/auth" className="Landing__cta-button-large">Попробовать бесплатно</a>
          </div>
        </section>
        
        <footer className="Landing__footer">
          <div className="Landing__content-container">
            <a href="/terms" className="Landing__footer-link">Пользовательское соглашение</a>
          </div>
        </footer>
    </div>
  );
};

export default Landing; 

